(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
$(function() {
  $('.js-accordion-item').click(function(){
    $('.fade').removeClass('fade');
    $('.active').siblings().addClass('fade');
  });
})

var accordion = (function(){

  var $accordion = $('.js-accordion');
  var $accordion_header = $accordion.find('.js-accordion-header');
  var $accordion_item = $('.js-accordion-item');
 
  // default settings 
  var settings = {
    // animation speed
    speed: 700,
    
    // close all other accordion items if true
    oneOpen: false,
  };
    
  return {
    // pass configurable object literal
    init: function($settings) {
      $accordion_header.on('click', function() {
        accordion.toggle($(this));
      });
      
      $.extend(settings, $settings); 
      
      // ensure only one accordion is active if oneOpen is true
      if(settings.oneOpen && $('.js-accordion-item.active').length > 1) {
        $('.js-accordion-item.active:not(:first)').removeClass('active');
      }
      
      // reveal the active accordion bodies
      $('.js-accordion-item.active').find('> .js-accordion-body').show();
    },
    toggle: function($this) {
            
      if(settings.oneOpen && $this[0] != $this.closest('.js-accordion').find('> .js-accordion-item.active > .js-accordion-header')[0]) {
        $this.closest('.js-accordion')
               .find('> .js-accordion-item') 
               .removeClass('active')
               .find('.js-accordion-body')
               .slideUp()
      }
      
      // show/hide the clicked accordion item
      $this.closest('.js-accordion-item').toggleClass('active');
      $this.next().stop().slideToggle(settings.speed);
    }
  }
})();

$(document).ready(function(){
  accordion.init({ speed: 700, oneOpen: true });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info"]) return;
  try {
    
  var accordion = (function(){

    var $accordion = $('.js-info-accordion');
    var $accordion_header = $accordion.find('.js-info-accordion-header');
    var $accordion_item = $('.js-info-accordion-item');
   
    // default settings 
    var settings = {
      // animation speed
      speed: 700,
      
      // close all other accordion items if true
      oneOpen: false,
    };
      
    return {
      // pass configurable object literal
      init: function($settings) {
        $accordion_header.on('click', function() {
          accordion.toggle($(this));
        });
        
        $.extend(settings, $settings); 
        
        // ensure only one accordion is active if oneOpen is true
        if(settings.oneOpen && $('.js-info-accordion-item.active').length > 1) {
          $('.js-info-accordion-item.active:not(:first)').removeClass('active');
        }
        
        // reveal the active accordion bodies
        $('.js-info-accordion-item.active').find('> .js-info-accordion-body').show();
      },
      toggle: function($this) {
              
        if(settings.oneOpen && $this[0] != $this.closest('.js-info-accordion').find('> .js-info-accordion-item.active > .js-info-accordion-header')[0]) {
          $this.closest('.js-info-accordion')
                 .find('> .js-info-accordion-item') 
                 .removeClass('active')
                 .find('.js-info-accordion-body')
                 .slideUp()
        }
        
        // show/hide the clicked accordion item
        $this.closest('.js-info-accordion-item').toggleClass('active');
        $this.next().stop().slideToggle(settings.speed);
      }
    }
  })();
  
  $(document).ready(function(){
    accordion.init({ speed: 700, oneOpen: false });
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journal-block"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.blog-swiper', {
    direction: 'horizontal',
    loop: true,
    speed: 600,
    spaceBetween: 40,
    autoplay: {
        delay: 4000,
        disableOnInteraction: true,
    },
    pagination: {
    el: '.swiper-pagination',
    },
}); 
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-block"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.products-swiper', {
      direction: 'horizontal',
      loop: true,
      speed: 600,
      spaceBetween: 40,
      autoplay: {
          delay: 4000,
          disableOnInteraction: true,
      },
      pagination: {
      el: '.swiper-pagination',
      },
  }); 
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Read product id from data attribute
  var productId = productRecommendationsSection.dataset.productId;
  // Read limit from data attribute
  var limit = productRecommendationsSection.dataset.limit;
  // Build request URL
  var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", requestUrl);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
    }
  };
  request.send();
};
// If your section has theme settings, the theme editor
// reloads the section as you edit those settings. When that happens, the
// recommendations need to be fetched again.
// See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
document.addEventListener("shopify:section:load", function(event) {
  if (event.detail.sectionId === "product-recommendations") {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
